import Constants from "src/utils/constants";
import Helper from "src/utils/helper";

export async function formatEmailBody(body) {
  if (!Helper.isStringValueExist(body)) return body ?? "";
  try {
    const { default: beautify } = await import("js-beautify");
    return beautify.html(body, Constants.constants.EMAIL_BODY_FORMAT_OPTIONS);
  } catch (error) {
    console.error("[bodyFormat] could not format email body", error);
    return body;
  }
}

export async function findUnpairedTags(body) {
  if (!Helper.isStringValueExist(body)) return [];
  const { HTMLHint } = await import("htmlhint");
  return HTMLHint.verify(body, { "tag-pair": true });
}
